<template>
  <div class="containerIndustry" id="containerIndustry">
    <a-tabs v-model="active" @change="callback">
    <a-tab-pane key="1" tab="行业列表">
        <div>
            <div style="margin-top: 10px">
                <a-button type="primary" @click="modification" style="margin-right: 5px">
                    新增行业
                </a-button>
            </div>
            <div class="content_main_top">
                <a-input v-model="query.industryCode" allowClear class="a_input_self margin_self" placeholder="行业编号"
                    @keyup.enter.native="industrySerch" />
                <a-input v-model="query.industryName" allowClear class="a_input_self margin_self" placeholder="行业名称"
                    @keyup.enter.native="industrySerch" />
                <a-button type="primary" @click="industrySerch" style="margin-left: 10px"> 查询 </a-button>
                <a-button type="primary" ghost @click="industryReset"> 重置 </a-button>
            </div>
            <div class="content_main_center_scroll" id="content_main_center_scroll" ref="centerTable">
                <a-table :columns="columnsList" :data-source="industryData" :scroll="{ y: scroll_y, scrollToFirstRowOnChange: true  }" bordered
                    :pagination="pagination" @change="changeTable">


                    <span slot="index" slot-scope="text, record, index">
                        {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                    </span>
                    <span slot="action" slot-scope="text, record">
                        <a @click="details(record)">详情</a>
                        <a-divider type="vertical" />
                        <a @click="edit(record)">编辑</a>
                        <a-divider type="vertical" />
                        <a @click="confirm(record)">删除</a>
                    </span>
                </a-table>
            </div>
        </div>
        <industry ref="industry" :type="type" @getIndustryList="getIndustry"></industry>
    </a-tab-pane>
    <a-tab-pane key="2" tab="岗位列表">
        <div>
            <div style="margin-top: 10px">
                <a-button type="primary" @click="postAdd" style="margin-right: 5px">
                    新增岗位
                </a-button>
            </div>
            <div class="content_main_top">
                <a-input v-model="query2.industryName" allowClear class="a_input_self margin_self"
                    placeholder="行业名称" @keyup.enter.native="querySerch" />
                <a-input v-model="query2.postName" allowClear class="a_input_self margin_self" placeholder="岗位名称"
                    @keyup.enter.native="querySerch" />
                <a-button type="primary" @click="querySerch" style="margin-left: 10px"> 查询 </a-button>
                <a-button type="primary" ghost @click="queryReset"> 重置 </a-button>
            </div>
            <div class="content_main_center_scroll" id="content_main_center_scroll" ref="centerTable">
                <a-table :columns="columnsList2" :data-source="postList" :scroll="{ y: scroll_y , scrollToFirstRowOnChange: true }" bordered
                    :pagination="pagination2" @change="changeTableclaim">
                    <span slot="index" slot-scope="text, record, index">
                        {{ (pagination2.current - 1) * pagination2.pageSize + index + 1 }}
                    </span>
                    <span slot="action" slot-scope="text, record">
                        <a @click="postdetails(record)">详情</a>
                        <a-divider type="vertical" />
                        <a @click="postedit(record)">编辑</a>
                         <a-divider type="vertical" />
                        <a @click="postDelete(record)">删除</a>
                    </span>
                </a-table>
            </div>

        </div>
        <post ref="post"></post>
        <addParameter ref="addParameter" @getPostData="getPostList"></addParameter>
        <editParamenter ref="editParamenter"  @getPostData="getPostList"></editParamenter>
    </a-tab-pane>
     <a-tab-pane key="3" tab="危害因素报价表">
      <div class="content_main" id="content_main">
				<div style="margin-top: 10px">
					<a-button type="primary" @click="factorsAdd" style="margin-right: 5px">
						新增危害因素
					</a-button>
				</div>
				<div class="content_main_top">
					<!-- <a-select allowClear placeholder="所属收费标准" v-model="query3.categoryId" class="a_input_self margin_self" @change="changeSubCategory"
						@keyup.enter.native="getIndustryData">
						<a-select-option :value="item.categoryId" v-for="(item, index) in factorsCateList" :key="index">
							{{ item.categoryName }}
						</a-select-option> -->
					<!-- </a-select> -->
					<a-select allowClear placeholder="所属子标准" v-model="query3.subcategoryId" class="a_input_self margin_self"
						@keyup.enter.native="getIndustryData">
						<a-select-option :value="item.categoryId" v-for="(item, index) in subcategoryList" :key="index">
							{{ item.categoryName }}
						</a-select-option>
					</a-select>
					<a-input v-model="query3.factorName" allowClear class="a_input_self margin_self" placeholder="危害因素"
						@keyup.enter.native="getIndustryData" />
					<a-button type="primary" @click="searchIndustryData" style="margin-left: 10px"> 查询 </a-button>
					<a-button type="primary" ghost @click="categoryReset"> 重置 </a-button>
				</div>
				<div class="content_main_center_scroll" id="content_main_center_scroll"  ref="centerTable">
					<a-table :columns="columnsList3" :data-source="industryList" :scroll="{ y: scroll_y , scrollToFirstRowOnChange: true }" bordered
						:pagination="pagination3" @change="changeTable3">
						<span slot="index" slot-scope="text, record, index">
							{{ (pagination3.current - 1) * pagination3.pageSize + index + 1 }}
						</span>
						<span slot="action" slot-scope="text, record">
							<a @click="categoryEdit(record)">编辑</a>
							<a-divider type="vertical" />
							<a @click="categoryDetails(record)">详情</a>
							<a-divider type="vertical" />
              <a @click="categoryDelete(record)">删除</a>
						</span>
					</a-table>
				</div>
      </div>
        <hazard ref="hazard" @rushHazard="getIndustryData"></hazard>
        <hazardDetail ref="hazardDetail" @rushHazard="getIndustryData"></hazardDetail>

    </a-tab-pane>
  </a-tabs>
  </div>
</template>

<script>

import hazard from './hazard.vue'
import post from './post.vue'
import industry from './industry.vue'
import addParameter from './addParameter.vue'
import hazardDetail from './hazardDetail.vue'
import editParamenter from './editParamenter.vue'
import { deletePostInfo } from '@/api/surrounding'
import {
  delete_factor,
  baseFactorDelete,
  getFactorDetail,
  getUserListDetail,
  industryInfo,
  industryInfo_post,
  postInfo,
  addPostWithHarmFactor,
  editPostWithHarmFactor,
  industryInfo_details,
  industryInfo_put,
  postInfo_details,
  postInfo_put,
  baseFactor,
  getCategoryTree,
  subCategory,
  baseFactor_add,
  factor_details,
  editFactors_put,
  factor_list,
  deleteIndustryInfo,
  deleteFactor,
  getUserList,
} from '@/api/Industry'
const columns = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    // width: 120,
    ellipsis: true,
  },
  {
    title: '危害因素名称',
    dataIndex: 'fullName',
    key: 'fullName',
  },
  {
    title: '单价(元)',
    dataIndex: 'price',
    key: 'price',
    // width: 80,
  },
]
const columnsList = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '行业编号',
    dataIndex: 'industryCode',
    key: 'industryCode',
    ellipsis: true,
  },
  {
    title: '行业名称',
    dataIndex: 'industryName',
    key: 'industryName',
    ellipsis: true,
  },
  {
    title: '所属项目',
    dataIndex: 'ownProject',
    key: 'ownProject',
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 180,
  },
]
const columnsList2 = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '行业名称',
    dataIndex: 'industryName',
    key: 'industryName',
    ellipsis: true,
  },
  {
    title: '岗位名称',
    dataIndex: 'postName',
    key: 'postName',
    ellipsis: true,
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    with: 200,
    scopedSlots: {
      customRender: 'action',
    },
  },
]
const columnsList3 = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    width: 70,
    ellipsis: true,
  },
  {
    title: '所属收费标准',
    dataIndex: 'category',
    key: 'category',
    ellipsis: true,
  },
  {
    title: '所属子标准',
    dataIndex: 'subcategory',
    key: 'subcategory',
    ellipsis: true,
  },
  {
    title: '危害因素',
    dataIndex: 'factorName',
    key: 'factorName',
    ellipsis: false,
  },
  {
    title: '检测标准',
    dataIndex: 'standardInfo',
    key: 'standardInfo',
    ellipsis: true,
  },
  {
    title: '限制范围',
    dataIndex: 'limitRange',
    key: 'limitRange',
    ellipsis: true,
  },
  {
    title: '单价(元)',
    dataIndex: 'price',
    key: 'price',
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 160,
  },
]

export default {
  data() {
    return {
      hazardIndex: undefined,
      factorsCateList: [],
      subcategoryList: [],
      industryList: [],
      query3: {
        categoryId: undefined,
        subcategoryId: undefined,
        factorName: ''

      },
      postType: undefined,
      type: undefined,
      active: '1',
      query: {
        // 行业编号
        industryCode: '',
        // 行业名称
        industryName: ''

      },
      scroll_y: 150,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
        pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
       pagination3: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
    //   行业列表数据
      industryData: {},
    //   岗位详情列表
      columns,
    //   行业
      columnsList,
    //   岗位
      columnsList2,
    //   危害因素
      columnsList3,
      query2: {
        industryName: '',
        postName: ''
      },
      postList: [],

    }
  },
  components: {
    hazard,
    post,
    industry,
    addParameter,
    hazardDetail,
    editParamenter
  },
  created() {
      // this.getIndustryData()
        //获取收费标准列表
      getCategoryTree().then((res1) => {
      if (res1.code == 200) {
        this.factorsCateList = res1.data
        for (var i = 0; i < this.factorsCateList.length; i++) {
        if (this.factorsCateList[i].categoryId == 1002) {
          this.subcategoryList = this.factorsCateList[i].childrenList
        }
      }
      } else {
        this.$message.error(res1.msg)
      }
    })
    // this.$refs.published.init()
    this.active = this.$route.query.select ? String(this.$route.query.select) : '1'
    if (this.active == 1) {
      this.$nextTick((res) => {
         this.getIndustry()
        // this.$refs.industry.init()
      })
    } else if (this.active == 2) {
      this.$nextTick((res) => {
        this.getPostList()
        // this.$refs.post.init()
      })
    } else if (this.active == 3) {
      console.log(this.active , 'this.active this.active this.active this.active ')
      console.log('11111111111111111')
      this.$nextTick((res) => {
        this.getIndustryData()
       
 
        // this.$refs.hazard.init()
      })
     
    }
     //表格位置
        this.$nextTick(() => {
        var max_h = $('#containerIndustry').height()
				this.scroll_y = max_h - 255
    })
  },
  methods: {
    searchIndustryData() {
        this.pagination3.current = 1
      this.pagination3.pageSize = 10
      this.getIndustryData()

    },
    // 危害因素列表删除
    categoryDelete(row) {
      var _this = this
            var id = row.id
           this.$confirm({
					title: '是否确认删除?',
					onOk() {
      baseFactorDelete(row.id).then((res) => {
        if (res.code == 200) {
          _this.$message.success('删除成功')
          // this.postvisible = false
          _this.getIndustryData()
        } else {
          _this.$message.error(res.msg)
        }
      })
					
					},
					onCancel() {
						_this.$message.warning('你点击了取消')
					},
					// class: 'test',
				})
   

    },
    //危害因素列表详情
    categoryDetails(row) {
      this.hazardIndex = 1
      console.log(row, 'row===================================')
        this.$refs.hazardDetail.init({
        hazardIndex: this.hazardIndex,
        rowData: row
      })

    },
    //危害因素列表编辑
    categoryEdit(row) {
      this.hazardIndex = 0
      this.$refs.hazardDetail.init({
        hazardIndex: this.hazardIndex,
        rowData: row
      })

    },
    changeTable3(pagination) {
      this.pagination3.current = pagination.current
      this.pagination3.pageSize = pagination.pageSize
      this.getIndustryData()
    },
     //收费子标准列表
    //    changeSubCategory(e) {
    //     this.query3.subcategoryId = undefined
    //     this.subcategoryList = []
    //   for (var i = 0; i < this.factorsCateList.length; i++) {
    //     if (this.factorsCateList[i].categoryId == e) {
    //       this.subcategoryList = this.factorsCateList[i].childrenList
    //     }
    //   }
    // },
    //获取危害因素列表
    getIndustryData() {
       baseFactor({
        pageSize: this.pagination3.pageSize,
        pageNum: this.pagination3.current,
        categoryId: 1002,
        subcategoryId: this.query3.subcategoryId,
        factorName: this.query3.factorName,
      }).then((res) => {
        this.industryList = res.data
        const pagination = {
          ...this.pagination3,
        }
        pagination.total = res.total
        this.pagination3 = pagination
      })
    },
    // 危害因素重置
    categoryReset() {
      // this.this.query3 = {}
      this.query3.categoryId = undefined,
      this.query3.subcategoryId = undefined,
      this.query3.factorName = ''
      this.getIndustryData()
      

    },
    //危害因素查询
    industryQuery() {

    },
    //新增危害因素
    factorsAdd(row) {
      this.$refs.hazard.init(row)
    },
    callback(key) {
      // console.log(key)
      if (key == 1) {
        this.$nextTick((res) => {
        this.getIndustry()
        //   this.$refs.industry.init()
        })
      } else if (key == 2) {
        this.$nextTick((res) => {
            this.getPostList()
        //   this.$refs.post.init()
        })
      }  else if (key == 3) {
        this.$nextTick((res) => {
           this.getIndustryData()
           
        //   this.$refs.hazard.init()
        })
      }
        //表格位置
        this.$nextTick((res) => {
          var max_h = $('#containerIndustry').height()
          console.log(max_h, 'max_h ===========================')
					this.scroll_y = max_h - 255
    })
    },
//    行业模块开始========================================


    // 新增行业事件
    modification() {
        this.type = 0
        this.$refs.industry.init()
    },
    //行业列表查询事件
    industrySerch() {
      //  this.pagination2.current = pagination.current
      this.pagination.pageSize = 10
        this.pagination.current = 1
        this.getIndustry()

    },
      //行业列表重置事件
    industryReset() {
        this.query = {}
        this.pagination.current = 1
        this.getIndustry()

    },
    //获得行业列表数据
    getIndustry() {
          industryInfo({
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        industryName: this.query.industryName,
        industryCode: this.query.industryCode,
        projectId: 1
      }).then((res) => {
        if(res.code == 200) {
            this.industryData = res.data
            const pagination = {
             ...this.pagination,
            }
            pagination.total = res.total
            this.pagination = pagination
        } else {
            this.$message.error(res.msg)
        }
      })
    },
    // 行业详情
     details(row) {
        this.type = 2
        this.$refs.industry.init(row.id)
    },
    //编辑行业
    edit(row) {
        this.type = 1
        this.$refs.industry.init(row.id)
     
    },
    //删除行业
    confirm(row) {
        var _this = this
        this.$confirm({
					title: '是否确认删除?',
		onOk() {
           deleteIndustryInfo(row.id).then((res) => {
        if (res.code == 200) {
          _this.$message.success('删除成功')
          //刷新列表
          _this.getIndustry()
        } else {
          _this.$message.error(res.msg)
        }
      })
					},
        onCancel() {
            _this.$message.warning('你点击了取消')
        },
					// class: 'test',
				})
    },
    // 行业列表分页
      changeTable(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getIndustry()
    },

// 行业模块结束========================================
// 岗位模块开始=========================================
    // 获取岗位列表数据
    getPostList() {
         postInfo({
        pageSize: this.pagination2.pageSize,
        pageNum: this.pagination2.current,
        postName: this.query2.postName,
        industryName: this.query2.industryName,
      }).then((res) => {
        this.postList = res.data
        const pagination = {
          ...this.pagination2,
        }
        pagination.total = res.total
        this.pagination2 = pagination
      })
    },
    //分页
    changeTableclaim(pagination) {
      this.pagination2.current = pagination.current
      this.pagination2.pageSize = pagination.pageSize
      this.getPostList()
    },
    //新增岗位
    postAdd(row) {
        this.postType = 0
          this.$refs.addParameter.init({
          postType: this.postType,
          rowId: row.id
         })
    },
    // 岗位查询
    querySerch() {
         this.pagination2.current = 1
         this.pagination2.pageSize = 10
        // this.pagination.current = 1
         this.getPostList()
    },
    // 岗位重置
    queryReset() {
        this.query2 = {}
        this.pagination2.current = 1
        this.getPostList()

    },
    // 岗位编辑
    postedit(row) {
        this.postType = 1
          this.$refs.editParamenter.init({
          postType: this.postType,
          rowId: row.id
         })
    },
    //岗位详情
    postdetails(row) {
        this.postType = 2
         this.$refs.post.init({
          postType: this.postType,
          rowId: row.id
         })
     
    },
    //岗位删除
    postDelete(row) {
        var _this = this
        this.$confirm({
					title: '是否确认删除?',
		    onOk() {
           deletePostInfo(row.id).then((res) => {
        if (res.code == 200) {
          _this.$message.success('删除成功')
          //刷新列表
          _this.getPostList()
        } else {
          _this.$message.error(res.msg)
        }
        })
					},
        onCancel() {
            _this.$message.warning('你点击了取消')
        },
					// class: 'test',
				})

    }
// 岗位模块结束=========================================




  },
}
</script>

<style scoped>
::v-deep .ant-tabs-tabpane-active {
  height: 100% !important;
}
.containerIndustry {
    height: 100%;
    padding: 10px;
}
</style>